import React from "react";
import EmptyPageLayout from "../components-app/EmptyPageLayout";
import "../styles/privacy-policy.scss";

export default class PrivacyPolicy extends React.Component {
  render() {
    return (
      <EmptyPageLayout title="App Privacy Policy" url="/privacypolicy">
        <div
          style={{
            backgroundColor: "#f0f0f0",
            width: "100vw",
            height: "100vh",
          }}
        >
          <iframe
            src="/documents/VPS_VAM_Privacy_Policy_October_2025.pdf"
            title="VPS Privacy Policy Oct 2025"
            style={{
              width: "100%",
              height: "100%",
            }}
          />
        </div>
      </EmptyPageLayout>
    );
  }
}
